import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	active: 0,
	loading: false,
	installed: false,
	language: null,
	country: null
};

const mapsConfig = createSlice({
	name: 'mapsConfig',
	initialState,
	reducers: {
		increaseActiveMapsCount: (state) => ({
			...state,
			active: state.active + 1
		}),
		decreaseActiveMapsCount: (state) => ({
			...state,
			active: state.active - 1
		}),
		setMapsLoading: (state, { payload }) => ({
			...state,
			loading: payload
		}),
		setMapsInstalled: (state, { payload }) => ({
			...state,
			installed: payload
		}),
		completeMapsInstallation: (state, { payload }) => ({
			...state,
			installed: true,
			loading: false,
			language: payload.language,
			country: payload.country
		})
	}
});

export const {
	increaseActiveMapsCount,
	decreaseActiveMapsCount,
	setMapsLoading,
	setMapsInstalled,
	completeMapsInstallation
} = mapsConfig.actions;

export default mapsConfig.reducer;
